function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE, stylePropType } from 'tss-core-lib-common';
import Icon from 'react-svg-ikon';

import Input from './Input';
import { IconButton } from './buttons';
import { IMG_ICON_LOOKING_GLASS, IMG_ICON_CROSS_LARGE } from '../img';

var styles = void 0;

var SearchInput = function SearchInput(_ref) {
  var onClear = _ref.onClear,
      props = _objectWithoutProperties(_ref, ['onClear']);

  return React.createElement(
    'div',
    { className: css(styles.container) },
    React.createElement(Icon, { src: IMG_ICON_LOOKING_GLASS, stroke: TSS_DARK_BLUE(), className: css(styles.icon) }),
    React.createElement(Input, Object.assign({}, props, { style: [onClear ? styles.inputRightPadding : styles.input, props.style], containerStyle: [styles.inputContainer, props.containerStyle] })),
    onClear ? React.createElement(
      IconButton,
      { onClick: onClear, containerStyle: styles.crossButton },
      React.createElement(Icon, { src: IMG_ICON_CROSS_LARGE, className: 'stroke ' + css(styles.crossIcon) })
    ) : null
  );
};

SearchInput.propTypes = {
  style: stylePropType,
  containerStyle: stylePropType,
  onClear: PropTypes.func
};

SearchInput.defaultProps = {
  style: null,
  containerStyle: null,
  onClear: null
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },

  icon: {
    position: 'absolute',
    top: '50%',
    left: '1.6rem',
    marginTop: -8,
    zIndex: 1
  },

  crossButton: {
    position: 'absolute',
    top: '50%',
    right: '1.2rem',
    marginTop: '-0.9rem',
    zIndex: 1
  },

  crossIcon: {
    width: '1.2rem',
    height: '1.2rem',
    color: TSS_DARK_BLUE(0.5),

    ':hover': {
      color: TSS_DARK_BLUE()
    }
  },

  inputContainer: {
    width: '100%'
  },

  input: {
    padding: '0 0.5rem 0 4.2rem'
  },

  inputRightPadding: {
    padding: '0 2.8rem 0 4.2rem'
  }
});

export default SearchInput;